import { useState, useRef, useEffect } from 'react';

export function useCurrencyInput(initialValue: number = 0) {
  const [digits, setDigits] = useState<string>(
    () => Math.round(initialValue * 100).toString()
  );
  const inputRef = useRef<HTMLInputElement>(null);

  const formatAmount = (value: string) => {
    const numeric = value.replace(/\D/g, '');
    const padded = numeric.padStart(3, '0');
    const dollars = padded.slice(0, -2);
    const cents = padded.slice(-2);
    const withCommas = parseInt(dollars, 10).toLocaleString('en-US');
    return `${withCommas}.${cents}`;
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key >= '0' && e.key <= '9') {
      e.preventDefault();
      setDigits(prev => (prev + e.key).replace(/^0+/, '') || '0');
    } else if (e.key === 'Backspace') {
      e.preventDefault();
      setDigits(prev => prev.slice(0, -1) || '0');
    }
  };

  useEffect(() => {
    const updated = Math.round(initialValue * 100).toString();
    if (updated !== digits) setDigits(updated);
  }, [initialValue]);

  const formattedValue = `${formatAmount(digits)}`;
  const numericValue = parseInt(digits || '0', 10) / 100;

  const onFocus = () => inputRef.current?.focus();

  const setNumber = (n: number) => {
    const next = Math.round(n * 100).toString();
    setDigits(next);
  };

  return { inputRef, formattedValue, numericValue, onKeyDown, onFocus, setNumber };
}
